'use client';

import { useEffect } from 'react';
import { useStore } from 'zustand';
import { usePathname, useRouter } from 'next/navigation';

import { EnvironmentNameEnum, getEnvironmentName } from '@/config/environment';
import { authStore } from '@/store/auth.store';
import { getLogger } from '@/logger/logger';
import { hasPersonalDataPendencies } from '@/utils/auth/registration-pendencies.util';

const COMPLETE_REGISTRATION_PATH = '/completar-cadastro';
const logger = getLogger('complete-registration-guard');

export function useCompleteRegistrationGuard() {
  const router = useRouter();
  const pathname = usePathname();
  const isProduction = getEnvironmentName() === EnvironmentNameEnum.PRODUCTION;
  const authStatus = useStore(authStore, (state) => state.authStatus);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const authenticatedUser = useStore(authStore, (state) => state.authenticatedUser);
  const isAuthReady = authStatus !== 'loading';

  useEffect(() => {
    if (isProduction || !isAuthReady || !isLoggedIn) {
      return;
    }

    const normalizedPathname = pathname.replace(/\/+$/, '') || '/';

    if (normalizedPathname === COMPLETE_REGISTRATION_PATH) {
      return;
    }

    if (!hasPersonalDataPendencies(authenticatedUser)) {
      return;
    }

    logger.info('Incomplete registration detected, redirecting to complete registration');
    router.replace(`${COMPLETE_REGISTRATION_PATH}?returnUrl=${encodeURIComponent(normalizedPathname)}`);
  }, [isProduction, isAuthReady, isLoggedIn, pathname, authenticatedUser, router]);
}
